import { SortByI } from 'src/adminPanel/components/offsetting/orders/filter/SortByI';
import { SCHEMA_OFFSETTING_COMMISSION_INVOICE_FILTER_FULL_SHAPE } from 'src/adminPanel/schema/OffsettingCommissionInvoiceFilter';
import { CommonAddressRequestFilter } from '../CommonAddressRequestFilter';

export class CommissionInvoiceRequestFilter extends CommonAddressRequestFilter {
    public partnerId?: number;
    public invoiceId?: string;
    public invoiceDateFrom?: Date;
    public invoiceDateTo?: Date;
    public totalAmountFrom?: number;
    public totalAmountTo?: number;
    public feeNoTax?: boolean;
    public feeReverseCharge?: boolean;
    public commissionNoTax?: boolean;
    public commissionReverseCharge?: boolean;
    public invoiceMandants?: string[];
    public invoicePositionMandants?: string[];
    public excludeInvoiceMandants?: string[];
    public magicSearch?: string;
    public sortBy?: SortByI[];
    public defaultPageSize?: string;

    constructor(json: any) {
        super(json);
        this.partnerId = json.partnerId || undefined;
        this.invoiceId = json.invoiceId || undefined;
        this.invoiceDateFrom = json.invoiceDateFrom || undefined;
        this.invoiceDateTo = json.invoiceDateTo || undefined;
        this.totalAmountFrom = json.totalAmountFrom || undefined;
        this.totalAmountTo = json.totalAmountTo || undefined;
        this.feeNoTax = json.feeNoTax || undefined;
        this.feeReverseCharge = json.feeReverseCharge || undefined;
        this.commissionNoTax = json.commissionNoTax || undefined;
        this.commissionReverseCharge = json.commissionReverseCharge || undefined;
        this.invoiceMandants =
            json.invoiceMandants && json.invoiceMandants.length > 0 ? json.invoiceMandants : undefined;
        this.invoicePositionMandants =
            json.invoicePositionMandants && json.invoicePositionMandants.length > 0
                ? json.invoicePositionMandants
                : undefined;
        this.excludeInvoiceMandants =
            json.excludeInvoiceMandants && json.excludeInvoiceMandants.length > 0
                ? json.excludeInvoiceMandants
                : undefined;
        this.magicSearch = json.magicSearch;
        this.sortBy = json.sortBy;
        this.defaultPageSize = json.defaultPageSize || undefined;
    }

    static fromCommissionInvoiceFilterForm(
        schema: SCHEMA_OFFSETTING_COMMISSION_INVOICE_FILTER_FULL_SHAPE
    ): CommissionInvoiceRequestFilter {
        const newCommissionInvoiceRequestFilter: CommissionInvoiceRequestFilter = new CommissionInvoiceRequestFilter(
            schema
        );

        newCommissionInvoiceRequestFilter.feeNoTax = this.booleanValue(schema.feeNoTax ?? '');
        newCommissionInvoiceRequestFilter.feeReverseCharge = this.booleanValue(schema.feeReverseCharge ?? '');
        newCommissionInvoiceRequestFilter.commissionNoTax = this.booleanValue(schema.commissionNoTax ?? '');
        newCommissionInvoiceRequestFilter.commissionReverseCharge = this.booleanValue(
            schema.commissionReverseCharge ?? ''
        );

        newCommissionInvoiceRequestFilter.totalAmountFrom = schema.totalAmountFrom
            ? Number.parseFloat(schema.totalAmountFrom.replaceAll(',', '.'))
            : undefined;
        newCommissionInvoiceRequestFilter.totalAmountTo = schema.totalAmountTo
            ? Number.parseFloat(schema.totalAmountTo?.replaceAll(',', '.'))
            : undefined;

        newCommissionInvoiceRequestFilter.defaultPageSize = schema.defaultPageSize || undefined;

        return newCommissionInvoiceRequestFilter;
    }

    static booleanValue = (stringBool: string) => {
        switch (stringBool) {
            case 'true':
                return true;
            case 'false':
                return false;
            default:
                return undefined;
        }
    };

    static toCommissionInvoiceFilterForm(commissionInvoiceRequestFilter: CommissionInvoiceRequestFilter) {
        const newSchema: SCHEMA_OFFSETTING_COMMISSION_INVOICE_FILTER_FULL_SHAPE = {};

        newSchema.partnerId = commissionInvoiceRequestFilter.partnerId?.toString();
        newSchema.invoiceId = commissionInvoiceRequestFilter.invoiceId;

        newSchema.invoiceDateFrom = commissionInvoiceRequestFilter.invoiceDateFrom
            ? new Date(commissionInvoiceRequestFilter.invoiceDateFrom)
            : undefined;
        newSchema.invoiceDateTo = commissionInvoiceRequestFilter.invoiceDateTo
            ? new Date(commissionInvoiceRequestFilter.invoiceDateTo)
            : undefined;
        newSchema.totalAmountFrom = commissionInvoiceRequestFilter.totalAmountFrom?.toString();
        newSchema.totalAmountTo = commissionInvoiceRequestFilter.totalAmountTo?.toString();

        newSchema.feeNoTax = commissionInvoiceRequestFilter.feeNoTax?.toString();

        newSchema.feeReverseCharge = commissionInvoiceRequestFilter.feeReverseCharge?.toString();
        newSchema.commissionNoTax = commissionInvoiceRequestFilter.commissionNoTax?.toString();
        newSchema.commissionReverseCharge = commissionInvoiceRequestFilter.commissionReverseCharge?.toString();

        newSchema.invoiceMandants = commissionInvoiceRequestFilter.invoiceMandants;
        newSchema.invoicePositionMandants = commissionInvoiceRequestFilter.invoicePositionMandants;
        newSchema.excludeInvoiceMandants = commissionInvoiceRequestFilter.excludeInvoiceMandants;
        newSchema.sortBy = commissionInvoiceRequestFilter.sortBy?.map(sortBy => ({
            ...sortBy,
            order: sortBy.order.toString(),
        }));
        newSchema.defaultPageSize = commissionInvoiceRequestFilter.defaultPageSize || undefined;

        return newSchema;
    }
}
